<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="pre-order">
                    <icon name="shopping-basket"></icon>
                    รายการสั่งซื้อ
                </b-nav-item>&nbsp
                <b-nav-item router-link to="purchase-order">
                    <icon name="file"></icon>
                    สร้าง PO
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "purchase-order-layout"
    }
</script>

<style scoped>

</style>